import React, { memo, FC, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import {
  makeStyles,
  shorthands,
  Button,
  Text,
  tokens,
} from '@fluentui/react-components';
import {
  Add16Regular,
  Subtract16Regular,
} from '@fluentui/react-icons';

export const useStyles = makeStyles({
  searchTermActionRow: {
    // cannot find better way, use this hack to align the button with the text
    display: 'inline-block',
    '& .search-term-added + .search-term-exclude': {
      left: '0',
    },
  },
  searchTermButton: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: 'normal',
    ...shorthands.padding('0px'),
    position: 'relative',
    // cannot find better way, use this hack to align the button with the text
    left: '-12px',
    top: '-2px',
  },
  leftSide: {
    ...shorthands.margin('0px', '8px', '0px', '0px'),
  },
});

export interface ISearchTermActionsProps {
  triggerSearchTermDrawer?: Function;
  searchTermStatus: string;
  i18n?: any;
  rowRawItem?: any;
}

export const SearchTermActions: FC<ISearchTermActionsProps> = memo(({
  triggerSearchTermDrawer,
  i18n,
  searchTermStatus,
  rowRawItem,
}: ISearchTermActionsProps) => {
  const classes = useStyles();
  const searchTermAdded = searchTermStatus.indexOf('Added') > -1;
  const searchTermExcluded = searchTermStatus.indexOf('Excluded') > -1;

  const onClickAdd = useCallback(() => {
    triggerSearchTermDrawer({
      isNegative: false,
      campaign: rowRawItem.Campaign,
      adGroup: rowRawItem.AdGroup,
      keywordText: rowRawItem.Text,
    });
  }, [rowRawItem, triggerSearchTermDrawer]);
  const onClickExclude = useCallback(() => {
    triggerSearchTermDrawer({
      isNegative: true,
      campaign: rowRawItem.Campaign,
      adGroup: rowRawItem.AdGroup,
      keywordText: rowRawItem.Text,
    });
  }, [rowRawItem, triggerSearchTermDrawer]);
  const addAction = useMemo(() => {
    if (!rowRawItem || !rowRawItem.Keyword || !rowRawItem.Keyword.Text) {
      return null;
    }

    if (searchTermAdded) {
      return (
        <Text size={200} className={classNames('search-term-added', classes.leftSide)}>{i18n.getString(_TL_('Added'))}</Text>
      );
    }

    return (
      <Button
        className={classNames('search-term-add', classes.searchTermButton, classes.leftSide)}
        size="small"
        appearance="transparent"
        icon={<Add16Regular />}
        onClick={onClickAdd}
      >
        {i18n.getString(_TL_('Add'))}
      </Button>
    );
  }, [classes.leftSide, classes.searchTermButton, i18n, onClickAdd, rowRawItem, searchTermAdded]);

  return (
    <div className={classNames('search-term-action-row', classes.searchTermActionRow)}>
      {addAction}
      {
        searchTermExcluded ? (
          <Text size={200} className={classNames('search-term-excluded')}>{i18n.getString(_TL_('Excluded'))}</Text>
        ) : (
          <Button
            className={classNames('search-term-exclude', classes.searchTermButton)}
            size="small"
            appearance="transparent"
            icon={<Subtract16Regular />}
            onClick={onClickExclude}
          >
            {i18n.getString(_TL_('Exclude'))}
          </Button>
        )
      }
    </div>
  );
});

SearchTermActions.defaultProps = {
  i18n: null,
  triggerSearchTermDrawer: undefined,
  rowRawItem: null,
};
